interface SpinnerProps {
  label?: string;
  /** Smaller inline spinner (e.g. inside a button). */
  inline?: boolean;
}

export function Spinner({ label, inline = false }: SpinnerProps) {
  return (
    <div className={inline ? "spinner spinner--inline" : "spinner"} role="status" aria-live="polite">
      <span className="spinner__ring" aria-hidden="true" />
      {label ? <span className="spinner__label">{label}</span> : null}
      {!label ? <span className="sr-only">Loading…</span> : null}
    </div>
  );
}
